// src/Component/api/url.ts

       export const BASE_URL = "https://api.openuidev.com"; // for test 

      // export const BASE_URL = "https://stage.mytriva.com"; //for stage


  //  export const BASE_URL = "https://admin.mytriva.com"; //for Production



export const API_URLS = {
  // Authentication endpoints
  SIGNIN: `${BASE_URL}/login_nutritionist/`,
  VERIFY_OTP: `${BASE_URL}/nutritionist_verify_otp/`,
  // apiFetch POSTs { refresh } and expects { success: "1", access }.
  // Refresh token is NOT rotated by the backend — only the access token is reissued.
  REFRESH_TOKEN: `${BASE_URL}/nutritionist_token_refresh/`,

  // Profile endpoints
  GET_PROFILE:  `${BASE_URL}/get_my_profile/`,
  UPDATE_PROFILE:  `${BASE_URL}/update_nutritionist/`,
  UPDATE_PROFILE_PICTURE: `${BASE_URL}/update_profile_picture/`,


  // Dashboard endpoints
  GET_DASHBOARD_STATS:  `${BASE_URL}/nutritionist_dashboard`,
  GET_TOTAL_ACTIVE_CLIENTS: (nutrist_id: string | number, status: string,page: string | number,search: string = "") =>
  `${BASE_URL}/get_nutritionist_client_dashboard_list/${nutrist_id}/?status=${status}&page=${page}&search=${encodeURIComponent(search)}`,

  // Chat endpoints - File upload
  UPLOAD_FILE: `${BASE_URL}/upload_file/`,

  // Client details endpoints
  GET_USER_PROFILE_DETAILS: (user_id: string | number) =>
    `${BASE_URL}/get_user_details_admin/${user_id}/`,

  //Client details endpoints - NutritionStats endpoints
  GET_NUTRITION_STATS: `${BASE_URL}/get_user_meal_plan_details_admin_nutrition/`,

    //Client details endpoints - Assign Meal Card endpoints
  GET_ASSIGN_MEAL_DATA: `${BASE_URL}/get_user_meal_plan_details/`,

  //Client details endpoints - WATER INTAKE, SLEEP CYCLE, GUT HEALTH, EXERCISE, SUPPLEMENTS, MEDICINE, VITALS
  GET_ALLLOGS_DETAILS:(user_id: string | number, date: string | number) =>
    `${BASE_URL}/get_nutritionist_client_details/${user_id}/?date=${date}`,

  //meal plan endpoints - get meal plan details for a user
  GET_MEAL_PLAN_DETAILS: (user_id: string | number) =>
    `${BASE_URL}/get_meal_plan_details/${user_id}/`,

  //meal plan endpoints - ADD meal plan details for a user
  ADD_MEAL_PLAN_DETAILS: `${BASE_URL}/add_complete_meal_plan_nutritionist/`,

    //meal plan endpoints - get global template
    GLOBLE_TEMPLATES_SUGGEST: (user_id: string | number) => `${BASE_URL}/templates_suggest/${user_id}/`,

    //meal plan endpoints - get global template details for a user i.e. preview
    GET_GLOBAL_TEMPLATE_DETAILS:(template_id: string | number,) =>`${BASE_URL}/templates/${template_id}/`,

    //meal plan endpoints -  meal plan suggest for Copy from assigned client
    MEAL_PLAN_SUGGEST: (user_id: string | number) => `${BASE_URL}/meal_plans_suggest/${user_id}/`,

    //meal plan endpoints - duplicat meal plan for Copy from assigned client
    MEAL_PLAN_DUPLICATE: `${BASE_URL}/meal_plans_duplicate/`,

    //meal plan endpoints - duplicat meal plan for Use a template
    MEAL_PLAN_DUPLICATE_TEMPLATE: `${BASE_URL}/meal_plans_duplicate_template/`,

    //meal plan endpoint -Copy from assigned client meal plan preview
    COPY_FROM_ASSIGNED_CLIENT_MEAL_PLAN_PREVIEW: (meal_plan_id: string | number) =>
      `${BASE_URL}/client_plan_detail/${meal_plan_id}/`,

    //meal plan endpoint -get count of plans for a user
    GET_MEAL_PLAN_COUNT: (user_id: string | number, cal_min: string | number = "", cal_max: string | number = "", protein_min: string | number = "", protein_max: string | number = "") =>
      `${BASE_URL}/suggestion_counts/${user_id}?cal_min=${cal_min}&cal_max=${cal_max}&protein_min=${protein_min}&protein_max=${protein_max}`,

    //meal plan endpoints -  meal plan filter for Use a template
    MEAL_PLAN_FILTER_TEMPLATE: (user_id: string | number) => `${BASE_URL}/template_filter/${user_id}/`,
    //meal plan endpoints -  meal plan filter for Copy from assigned client
    MEAL_PLAN_FILTER_ASSIGNED_CLIENT: (user_id: string | number) => `${BASE_URL}/client_plan_filter/${user_id}/`,
    //meal plan endpoints -  for get client list in create meal plan
    GET_CLIENT_LIST_FOR_MEAL_PLAN: (search: string = "") =>
      `${BASE_URL}/get_user_list_for_filter/${search.trim() ? `?search=${encodeURIComponent(search.trim())}` : ""}`,

  //meal plan endpoints - update meal plan details for a user
  UPDATE_MEAL_PLAN_DETAILS: `${BASE_URL}/update_meal_time/`,

  //meal plan endpoints - open meal plan details for a user
  GET_MEAL_PLAN_DETAIL: `${BASE_URL}/get_meal_plan_new/`,

  //Get all dishes for a meal plan — optional `search` param passed to server
  GET_ALL_DISHES_MEAL_PLAN: (user_id: string | number, search: string = "") =>
    `${BASE_URL}/get_all_dishes_admin/?search=${encodeURIComponent(search)}&fk_user_id=${user_id}`,

  //meal plan endpoints - autocomplte dish name for a user
  AUTOCOMPLETE_DISH_NAME: ( search: string = "") =>
    `${BASE_URL}/dish_autocomplete/?q=${encodeURIComponent(search)}`,

  //meal plan endpoints - get the dish's measurement list for the meal-plan flow
  GET_DISH_MEASUREMENT_LIST: (dish_id: string | number) =>
    `${BASE_URL}/get_dish_measurement_list/?dish_id=${dish_id}/`,

  //meal plan endpoints - Create to meal plan
  CREATE_MEAL_PLAN: `${BASE_URL}/add_dish_items_nutritionist/`,

  //meal plan endpoints - delete meal card from meal plan
  DELETE_MEAL_CARD_PLAN:`${BASE_URL}/delete_option/`,

  //meal plan endpoints - delete meal plan
  DELETE_MEAL_PLAN: `${BASE_URL}/delete_meal_plan_by_team/`,

  //meal plan endpoints - update meal plan
  UPDATE_MEAL_PLAN: `${BASE_URL}/update_meal_options_nutritionist/`,

  //meal plan endpoint - send to client for approval
  MEAL_PLAN_SEND_TO_CLIENT: `${BASE_URL}/create_meal_approval_nutritionist/`,

  //meal plan endpoint - create duplicate meal plan for user
  DUPLICATE_MEAL_PLAN: `${BASE_URL}/get_duplicate_details_nutritionist/`,

  //meal plan endpoint - Duplecate meal option for user
  DUPLICATE_MEAL_OPTION: `${BASE_URL}/get_duplicate_option_details_nutritionist/`,

  //meal plan endpoint - get the meal plan type in create meal plan page
  GET_MEAL_PLAN_TYPE_LIST: `${BASE_URL}/get_all_meal_plan_type_list/`,

  //Gudelines endpoints - get all guidelines
  GET_ALL_GUIDELINES: (user_id: string | number, status: string) =>
     `${BASE_URL}/get_all_guidelines/${user_id}/?status=${status}`,

  //Gudelines endpoints - Upload guideline
  UPLOAD_GUIDELINE: `${BASE_URL}/upload_guideline/`,

  //Gudelines endpoints - Get all guideline categories
  GET_ALL_GUIDELINE_CATEGORIES: `${BASE_URL}/get_all_guideline_categories/`,

  //Exersise endpoints - get all exercises
  GET_ALL_EXERCISES: (user_id: string | number) =>
    `${BASE_URL}/get_nutritionist_user_exercise_details/${user_id}/`,

  //Exersise endpoints - Create exercise
  CREATE_EXERCISE: (user_id: string | number) =>
    `${BASE_URL}/create_exercises/${user_id}/`,

  //Exersise endpoints - Get all exercise type list
  GET_ALL_EXERCISE_TYPE_LIST: `${BASE_URL}/get_exercise_types_list/`,


  //Supplements endpoints - get all supplements
  GET_ALL_SUPPLEMENTS: (user_id: string | number) =>
    `${BASE_URL}/get_supplements_data_nutrition/${user_id}/`,

  //Supplements endpoints - ADD supplement
  ADD_SUPPLEMENT:  `${BASE_URL}/add_supplement/`,

  //water intake endpoints - get water intake details
  GET_WATER_INTAKE_DETAILS: (user_id: string | number) =>
    `${BASE_URL}/get_water_cycles/${user_id}`,

  //water intake endpoints - Create water intake details
  CREATE_WATER_INTAKE:  `${BASE_URL}/create_water_cycle/`,

  //Recipe endpoint - Get recipe list with pagination and optional server-side search
  GET_RECIPE_LIST: (
    user_id: string | number,
    page: number,
    size: number,
    search: string = ""
  ) =>
    `${BASE_URL}/get_recipes_details/?fk_user_id=${user_id}&page=${page}&size=${size}${
      search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ""
    }`,

  //Recipe endpoint - Get ingredient list for a recipe with optional search
  GET_INGREDIENT_LIST: (recipe_id: string | number, search: string = "") =>
    `${BASE_URL}/get_copy_ingredients/?recipe_id=${recipe_id}${
      search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ""
    }`,

  //Insights endpoints - get weekly user stats
  GET_WEIGHT_CHART_DATA: (user_id: string ) =>
    `${BASE_URL}/get_weights/${user_id}`,

  GET_INSIGHTS_WEEKLY_DATA: (user_id: string | number, reference_date: string) =>
    `${BASE_URL}/get_weekly_team_insights/${user_id}/?reference_date=${reference_date}`,

  GET_INSIGHTS_FORTNIGHTLY_DATA: (user_id: string | number, reference_date: string) =>
      `${BASE_URL}/get_fortnightly_team_insights/${user_id}/?reference_date=${reference_date}`,

  GET_INSIGHTS_MONTHLY_DATA: (user_id: string | number, reference_date: string) =>
    `${BASE_URL}/get_monthly_team_insights/${user_id}/?reference_date=${reference_date}`,

//Global template endpoints 
  //Global template endpoints - get global template list
  GET_GLOBAL_TEMPLATE_LIST: (page: number = 1, page_size: number = 12, search: string = "", meal_plan_type: string = "", meals_per_day: string = "", options_per_meal: string = "", nutritionist_ids: number[] = []) => {
    const params = new URLSearchParams({ page: String(page), page_size: String(page_size) });
    if (search.trim()) params.set("search", search.trim());
    if (meal_plan_type) params.set("meal_plan_type", meal_plan_type);
    if (meals_per_day) params.set("meals_per_day", meals_per_day);
    if (options_per_meal) params.set("options_per_meal", options_per_meal);
    if (nutritionist_ids.length > 0) params.set("nutritionist_ids", nutritionist_ids.join(","));
    return `${BASE_URL}/templates/?${params.toString()}`;
  },

    //Global template endpoints - create global template
    CREATE_GLOBAL_TEMPLATE: `${BASE_URL}/create_template/`,

    //Global template endpoints - create meal otions for global template
    CREATE_GLOBAL_TEMPLATE_MEAL_OPTIONS:(template_id: string | number,) => `${BASE_URL}/add_template_option/${template_id}/`,
    //Global template endpoints - create meal otions for global template
    UPDATE_GLOBAL_TEMPLATE_MEAL_OPTIONS:(template_id: string | number,) => `${BASE_URL}/update_template_option/${template_id}/`,
    //Global template endpoints - delete meal otions for global template
    DELETE_GLOBAL_TEMPLATE_MEAL_OPTIONS:(template_id: string | number,) => `${BASE_URL}/delete_template_option/${template_id}/`,
    //Global template endpoints - update templet meal time 
    UPDATE_GLOBAL_TEMPLATE_MEAL_TIME:`${BASE_URL}/update_template_meal_time/`,
    //Global template endpoints - duplicate meal otions for global template
    DUPLICATE_GLOBAL_TEMPLATE_MEAL_OPTIONS: `${BASE_URL}/duplicate_template_option/`,


    //Global template endpoints - publish global template
    PUBLISH_GLOBAL_TEMPLATE: (template_id: string | number,) => `${BASE_URL}/publish_template/${template_id}/`,
    
    //Global template endpoints - update templet name
    UPDATE_TEMPLET_NAME:(template_id: string | number,) => `${BASE_URL}/rename_template_name/${template_id}/`,

    //Global template endpoints - suggest_plan for global template
    SUGGEST_PLAN_GLOBAL_TEMPLATE:  `${BASE_URL}/suggest_plan/`,

    //Global template endpoints - get global template suggested plan
    GET_SUGGESTED_PLAN_GLOBAL_TEMPLATE: (status: string = "pending", page: number = 1, page_size: number = 10, search: string = "") =>
  `${BASE_URL}/pending_suggestions/?status=${status}&page=${page}&page_size=${page_size}${search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ""}`,

    //Global template endpoints - get global template suggested plan details
    GET_SUGGESTED_PLAN_GLOBAL_TEMPLATE_DETAILS: (suggestion_id: string | number,) => `${BASE_URL}/suggestion_detail/${suggestion_id}/`,

    //Global template endpoints - approve a suggested plan
    APPROVE_SUGGESTION: (suggestion_id: string | number) => `${BASE_URL}/approve_suggestion/${suggestion_id}/`,

    //Global template endpoints - reject a suggested plan
    REJECT_SUGGESTION: (suggestion_id: string | number) => `${BASE_URL}/decline_suggestion/${suggestion_id}/`,
  

    //Global template endpoints - get rejected/declined suggestions list
    GET_REJECTED_SUGGESTIONS: (page: number = 1, page_size: number = 10, search: string = "") =>
      `${BASE_URL}/rejected_suggestions/?status=declined&page=${page}&page_size=${page_size}${search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ""}`,
  
    //sales module endpoints
  SALES_DASHBOARD: `${BASE_URL}/nutritionist_sales_dashboard/`,

  GET_USER_SALES_JOURNEY: (user_id: string | number) =>
    `${BASE_URL}/get_user_journey/?user_id=${user_id}`,

  UPDATE_SALES_JOURNEY_COMPLETED_CALL_REQUEST: `${BASE_URL}/complete_callback_request/`,
  UPDATE_SALES_JOURNEY_SCHEDULE_MEETING: `${BASE_URL}/update_journey_step/`,

  //Assign nutritionist endpoints
  // GET_AVAILABLE_NUTRITIONISTS_LIST: `${BASE_URL}/get_nutritionists/`,
  GET_AVAILABLE_NUTRITIONISTS_LIST: `${BASE_URL}/list_nutritionists/`, 
  ASSIGN_PRIMARY_NUTRITIONIST: `${BASE_URL}/assign_primary_nutritionist/`,
  ASSIGN_BACKUP_NUTRITIONIST: `${BASE_URL}/assign_backup_nutritionist/`,
  GET_ASSIGNED_NUTRITIONISTS: (user_id: string | number) =>
    `${BASE_URL}/get_assigned_nutritionists/?user_id=${user_id}`,

  // User endpoints (used for chat group creation)
  GET_USER: (user_id: string | number) =>
    `${BASE_URL}/get_user/${user_id}/`,
  GET_USER_INFO: (user_id: string | number) =>
    `${BASE_URL}/get_user_info/${user_id}/`,

  //sales client details endpoints
  GET_SALES_CLIENT_DETAILS_LIST: (
    lifecycle: "client" | "churned" | "all" = "all",
    assignment: "assigned" | "unassigned" | "all" = "all",
    page: number = 1,
    page_size: number = 10,
    search_user: string = ""
  ) => {
    const params = new URLSearchParams({
      lifecycle,
      assignment,
      page: String(page),
      page_size: String(page_size),
    });
    if (search_user.trim()) params.set("search_user", search_user.trim());
    return `${BASE_URL}/get_client_or_churned_user_list/?${params.toString()}`;
  },

//Role based access control endpoints

  //get list of Nutritionists
  GET_NUTRITIONISTS_LIST_WITH_ASSIGN_ROLE: (
    nutrist_assign_role: string = "",
    nutrist_status: string = "",
    page: number = 1,
    size: number = 10,
    nutrist_name: string = "",
  ) => {
    const params = new URLSearchParams({
      page: String(page),
      size: String(size),
    });
    if (nutrist_assign_role.trim())
      params.set("nutrist_assign_role", nutrist_assign_role.trim());
    if (nutrist_status.trim())
      params.set("nutrist_status", nutrist_status.trim());
    if (nutrist_name.trim())
      params.set("nutrist_name", nutrist_name.trim());
    return `${BASE_URL}/get_nutritionists_with_assign_roles?${params.toString()}`;
  },

  //Get list of temporary roles and permissions to assign to nutritionist
  GET_TEMPORARY_ROLES_AND_PERMISSIONS_DROPDOWN_VALUES: `${BASE_URL}/rbac_dropdown_data/`,
  //Get details of the nutrionist with its detilas and assigned role and permissions 
  GET_NUTRITIONIST_DETAILS_WITH_ROLE: (nutritionist_id: string | number) =>
    `${BASE_URL}/nutritionist_permissions_detail/${nutritionist_id}/`,
  //get list of prmisions withrespective role select
  GET_PERMISSIONS_LIST_WITH_ROLE: (nutritionist_id: string | number, role: string) =>
    `${BASE_URL}/preview_permissions_for_role/${nutritionist_id}/${encodeURIComponent(role)}/`,
  //Assign role to temporary role to nutritionist 
  ASSIGN_ROLE_TO_NUTRITIONIST: `${BASE_URL}/change_role_permissions/`,


  //Get list of permissions according to role
  GET_PERMISSIONS_LIST_FOR_ROLE: (role: string ) =>
    `${BASE_URL}/role_access_detail/${role}/`,
  //save assigned permissions to particular role
  SAVE_ASSIGNED_PERMISSIONS_TO_ROLE: (role: string ) =>
    `${BASE_URL}/role_access_save/${role}/`,
  //Enable all permissions for a particular role
  ENABLE_ALL_PERMISSIONS_FOR_ROLE: (role: string ) =>
    `${BASE_URL}/role_access_enable_all/${role}/`,
  //Disable all permissions for a particular role
  DISABLE_ALL_PERMISSIONS_FOR_ROLE: (role: string ) =>
    `${BASE_URL}/role_access_disable_all/${role}/`,

  //Create new permission 
  CREATE_NEW_PERMISSION: `${BASE_URL}/create_permission/`,

  //view nutritionist full details 
  GET_NUTRITIONIST_FULL_DETAILS: (nutritionist_id: string | number) =>
    `${BASE_URL}/get_nutritionists/${nutritionist_id}/`,

  //Add new nutritionist
  ADD_NEW_NUTRITIONIST: `${BASE_URL}/add_nutritionist/`,

  //Update nutritionist details
  UPDATE_NUTRITIONIST_DETAILS: `${BASE_URL}/update_nutritionist/`,

  //Master list of all dropdown values apis
  //STEP 1
  GET_STATE_LIST: `${BASE_URL}/get_nutritionist_states/`,
  GET_DOCUMENT_TYPES: `${BASE_URL}/get_document_type_list/`,
  //STEP 2
  GET_QUALIFICATION_TYPES: `${BASE_URL}/get_education_qualification_list/`,
  GET_SPECIALIZATION_LIST: `${BASE_URL}/get_specialisation_list/`,
  GET_EXPERTISE_TYPES: `${BASE_URL}/get_nutritionist_expertise/`,
  GET_CERTIFICATION_TYPES: `${BASE_URL}/get_all_certifications/`,
  GET_LANGUAGE_LIST: `${BASE_URL}/get_language_list/`,
  //STEP 3
  GET_NUTRITIONIST_ROLE: `${BASE_URL}/get_nutritionist_assign_roles/`,
  GET_NUTRITIONIST_JOB_TYPES: `${BASE_URL}/get_nutritionist_job_type/`,
  GET_REPORTING_MANAGER_LIST: `${BASE_URL}/get_reporting_managers/`,

//meal (Dish and Ingredient) endpoints
  //Ingredient endpoints - get ingredient list with pagination, optional filter (active/archive),
  //optional creator filter (nutritionist_id) and optional server-side search
  GET_LIST_IN_INGREDIENT_DASHBOARD: (
    filter: "" | "active" | "archive" = "",
    created_by: string | number = "",
    search: string = "",
    page: number = 1,
    size: number = 10,
  ) => {
    const params = new URLSearchParams({
      page: String(page),
      size: String(size),
    });
    if (filter) params.set("filter", filter);
    if (created_by !== "" && created_by !== 0) params.set("created_by", String(created_by));
    if (search.trim()) params.set("search", search.trim());
    return `${BASE_URL}/get_meal_food_item_list/?${params.toString()}`;
  },

  //get ingredient details for a given ingredient_id
  GET_INGREDIENT_DETAILS: (food_id: string | number) =>
    `${BASE_URL}/get_ingredient_details/?food_id=${food_id}`,

  //Ingredient endpoints - create new ingredient
  CREATE_INGREDIENT: `${BASE_URL}/add_food_item/`,

  //Ingredient endpoints - update ingredient details
  UPDATE_INGREDIENT:(food_id: string | number) => `${BASE_URL}/update_food_item/${food_id}/`,

  //Ingredient endpoints - archive or restore ingredient details
  ARCHIVE_OR_RESTORE_INGREDIENT: `${BASE_URL}/update_ingredient_hide_status/`,

  //check if ingredient name already exists
  CHECK_INGREDIENT_NAME_EXISTS: (ingredient_name: string) =>
    `${BASE_URL}/check_ingredient_name_exists/?item_name=${encodeURIComponent(ingredient_name)}`,

  //Download excel template for bulk upload of ingredients.
  //  variant "normal" — blank template used by the "Import new" flow.
  //  variant "rename" — pre-filled template used by the "Modify existing" flow.
  DOWNLOAD_INGREDIENT_BULK_UPLOAD_TEMPLATE: (variant: "normal" | "rename") =>
    `${BASE_URL}/download_ingredient_upload_template/?variant=${variant}`,

  //upload exacl file for bulk upload of ingredients.
  UPLOAD_INGREDIENT_BULK_UPLOAD: `${BASE_URL}/ingredient_upload_excel/`,

  //Re-post the same sheet with ?download_errors=true — the backend replies
  //with an annotated Excel file (errors highlighted / column mismatches
  //flagged) instead of a JSON summary, for the user to fix and re-upload.
  UPLOAD_INGREDIENT_BULK_UPLOAD_DOWNLOAD_ERRORS: `${BASE_URL}/ingredient_upload_excel/?download_errors=true`,

  //Master list of all dropdown values apis
  GET_INGREDIENT_CATEGORIES: `${BASE_URL}/get_food_category_list/`,
  GET_UNITS_LIST: `${BASE_URL}/get_unit_list/`,

  //Dish endpoints - get dish list with pagination, optional filter (active/archive),
  //optional creator filter (nutritionist_id) and optional server-side search
  GET_LIST_IN_DISH_DASHBOARD: (
    filter: "" | "active" | "archive" = "",
    created_by: string | number = "", 
    search: string = "",
    page: number = 1,
    size: number = 10,
  ) => {
    const params = new URLSearchParams({
      page: String(page),
      size: String(size),
    });
    if (filter) params.set("filter", filter);
    if (created_by !== "" && created_by !== 0) params.set("created_by", String(created_by));
    if (search.trim()) params.set("search", search.trim());
    return `${BASE_URL}/get_meal_dish_item_list/?${params.toString()}`;
  },

  //Dish endpoints - create new dish (multipart/form-data with dish_image + composition fields)
  CREATE_DISH: `${BASE_URL}/add_dish/`,

  //Dish endpoints - update dish details (multipart/form-data with dish_image + composition fields)
  UPDATE_DISH: `${BASE_URL}/update_dish_details/`,


  //Admin ingredient search — backs the dish calculator's row picker.
  //  search — icontains match on item_name
  //  limit  — max rows to return (dropdown lists stay small)
  GET_ALL_INGREDIENTS_ADMIN: (search: string, limit: number = 20) =>
    `${BASE_URL}/get_all_ingredients_admin/?search=${encodeURIComponent(search)}&limit=${limit}`,
  
  //dish endpoints- get dish details for a given dish_id
  GET_DISH_DETAILS: (dish_id: string | number) =>
    `${BASE_URL}/get_dish_detail/${dish_id}/`,

  //Dish endpoints - archive or restore dish details
  ARCHIVE_OR_RESTORE_DISH: `${BASE_URL}/update_dish_hide_status/`,

  //check if dish name already exists
  CHECK_DISH_NAME_EXISTS: (dish_name: string) =>
    `${BASE_URL}/check_dish_name_exists/?dish_name=${encodeURIComponent(dish_name)}`,

  //Download excel template for bulk upload of dishes.
  //  variant "normal" — blank template used by the "Import new" flow.
  //  variant "rename" — pre-filled template used by the "Modify existing" flow.
  DOWNLOAD_DISH_BULK_UPLOAD_TEMPLATE: (variant: "normal" | "rename") =>
    `${BASE_URL}/download_dish_upload_template/?variant=${variant}`,

  //upload exacl file for bulk upload of dishes.
  UPLOAD_DISH_BULK_UPLOAD: `${BASE_URL}/dish_upload_excel/`,

  //Re-post the same sheet with ?download_errors=true — the backend replies
  //with an annotated Excel file (errors highlighted / column mismatches
  //flagged) instead of a JSON summary, for the user to fix and re-upload.
  UPLOAD_DISH_BULK_UPLOAD_DOWNLOAD_ERRORS: `${BASE_URL}/dish_upload_excel/?download_errors=true`,


//adhoc endpoints
  //adhoc endpoints - get all meal plan list — supports search (plan_name / plan_code / client name),
  //plan_type (comma-separated multi-select), category, status, creator (nutritionist_id),
  //created-on date window, sort + pagination.
  GET_ALL_ADHOC_MEAL_PLAN_LIST: (
    search: string = "",
    status: string = "",
    plan_type: string = "",
    category_id: string | number = "",
    nutritionist_id: string | number = "",
    created_from: string = "",
    created_to: string = "",
    sort_by: string = "",
    sort_order: string = "",
    page: number = 1,
    page_size: number = 20,
  ) => {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(page_size),
    });
    if (search.trim()) params.set("search", search.trim());
    if (status.trim()) params.set("status", status.trim());
    if (plan_type.trim()) params.set("plan_type", plan_type.trim());
    if (category_id !== "" && category_id !== 0) params.set("category_id", String(category_id));
    if (nutritionist_id !== "" && nutritionist_id !== 0) params.set("nutritionist_id", String(nutritionist_id));
    if (created_from.trim()) params.set("created_from", created_from.trim());
    if (created_to.trim()) params.set("created_to", created_to.trim());
    if (sort_by.trim()) params.set("sort_by", sort_by.trim());
    if (sort_order.trim()) params.set("sort_order", sort_order.trim());
    return `${BASE_URL}/list_adhoc_plans/?${params.toString()}`;
  },

  //adhoc endpoints - get adhoc meal plan details for a given adhoc_plan_id
  GET_ADHOC_MEAL_PLAN_DETAILS: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/get_adhoc_plan_detail/${adhoc_plan_id}/`,

  //adhoc endpoints - give list of categories for adhoc meal plan
  GET_ADHOC_MEAL_PLAN_CATEGORIES: `${BASE_URL}/list_adhoc_categories/`,

  //adhoc endpoints - create new adhoc meal plan from scratch
  CREATE_ADHOC_MEAL_PLAN_FORM_SCRATCH: `${BASE_URL}/create_adhoc_plan/`,

  //adhoc endpoints - create new adhoc meal plan from a template
  CREATE_ADHOC_MEAL_PLAN_FROM_TEMPLATE: `${BASE_URL}/create_adhoc_plan_from_template_view/`,

  //adhoc endpoints - create new adhoc meal plan from an existing client plan
  CREATE_ADHOC_MEAL_PLAN_FROM_EXISTING_CLIENT_PLAN: `${BASE_URL}/create_adhoc_plan_from_user_plan_view/`,

  //adhoc endpoints - add adhoc meal plan options for a given adhoc_plan_id
  ADD_ADHOC_MEAL_PLAN_OPTIONS: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/add_adhoc_option/${adhoc_plan_id}/`,

  //adhoc endpoints - update adhoc meal plan options for a given adhoc_plan_id
  UPDATE_ADHOC_MEAL_PLAN_OPTIONS: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/update_adhoc_option/${adhoc_plan_id}/`,

  //adhoc endpoints - delete adhoc meal plan options for a given adhoc_plan_id
  DELETE_ADHOC_MEAL_PLAN_OPTIONS: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/delete_adhoc_option/${adhoc_plan_id}/`,

  //adhoc endpoints - duplicate adhoc meal plan options
  DUPLICATE_ADHOC_MEAL_PLAN_OPTIONS: `${BASE_URL}/duplicate_adhoc_option/`,

  //adhoc endpoints - rename adhoc meal plan for a given adhoc_plan_id
  RENAME_ADHOC_MEAL_PLAN: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/rename_adhoc_plan/${adhoc_plan_id}/`,

  //adhoc endpoints - update meal time 
  UPDATE_ADHOC_MEAL_PLAN_MEAL_TIME: `${BASE_URL}/update_adhoc_meal_time/`,

  //adhoc endpoints - publish adhoc meal plan for a given adhoc_plan_id
  PUBLISH_ADHOC_MEAL_PLAN: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/publish_adhoc_plan/${adhoc_plan_id}/`,

  //adhoc enpoints - Download adhoc meal plan for a given adhoc_plan_id
  DOWNLOAD_ADHOC_MEAL_PLAN: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/download_adhoc_plan_pdf/${adhoc_plan_id}/`,

  //adhoc endpoints - duplicate adhoc meal plan 
  DUPLICATE_ADHOC_MEAL_PLAN: `${BASE_URL}/duplicate_adhoc_plan/`,

  //adhoc endpoint - edit nutrient values for a given adhoc_plan_id
  EDIT_ADHOC_MEAL_PLAN_NUTRIENT_VALUES: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/save_adhoc_plan_parameters/${adhoc_plan_id}/`,

  //adhoc endpoint - assign adhoc meal plan to a client for a given adhoc_plan_id
  ASSIGN_ADHOC_MEAL_PLAN_TO_CLIENT:  `${BASE_URL}/assign_adhoc_plan_to_client_view/`,

  //adhoc endpoint - archive adhoc meal plan 
  ARCHIVE_ADHOC_MEAL_PLAN: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/archive_adhoc_plan/${adhoc_plan_id}/`,

  //adhoc endpoint - restore adhoc meal plan 
  RESTORE_ADHOC_MEAL_PLAN: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/restore_adhoc_plan/${adhoc_plan_id}/`,

  //adhoc endpoint - delete adhoc meal plan 
  DELETE_ADHOC_MEAL_PLAN: (adhoc_plan_id: string | number) =>
    `${BASE_URL}/delete_adhoc_draft_plan/${adhoc_plan_id}/`,


};




// ── Firebase collection names ──────────────────────────────────────────────
//
// Automatically derived from BASE_URL so switching environments is a
// single-line change (BASE_URL above).  No .env files needed.
//
//   Production  → https://admin.mytriva.com   → chatgroupprod  / usersprod
//   Stage       → https://stage.mytriva.com   → chatgrouppreprod / userpreprod

const IS_PRODUCTION = (BASE_URL as string) === "https://admin.mytriva.com";

export const FIREBASE_COLLECTIONS = {
  CHAT_GROUPS: IS_PRODUCTION ? "chatgroupprod"    : "chatgrouppreprod",
  USERS:       IS_PRODUCTION ? "usersprod"         : "userpreprod",
};
